import { UserExtendedDTO } from '../../models/user/user-b2c-flow-dto.model';

/**
 * The staff user an ID token describes, for POST {Identity}/users.
 *
 * A B2C token carries `emails` and the given/family names. A workforce (Entra) token — the Klidi deployment signs staff
 * in to bizcombo.tech — has `email` only as an optional claim, always has `preferred_username` (the UPN), and gives
 * the names only in `name` unless the optional claims are configured. Reading `emails[0]` alone threw on those.
 */
export function staffUserFromClaims(claims: any): UserExtendedDTO {
  const [first, ...rest] = String(claims?.name ?? '').trim().split(/\s+/);
  return {
    azureObjectId: claims?.oid,
    email: claims?.emails?.[0] ?? claims?.email ?? claims?.preferred_username,
    firstName: claims?.given_name ?? (first || undefined),
    lastName: claims?.family_name ?? (rest.join(' ') || undefined),
  };
}

/**
 * The B2C user flow a token came from, or undefined for a token with none (every workforce token). B2C puts it in
 * `tfp` or, for older policies, `acr`; a workforce v1 token's `acr` ("1") is not a policy.
 */
export function b2cPolicyOf(claims: { acr?: string; tfp?: string } | undefined): string | undefined {
  return [claims?.tfp, claims?.acr].find(p => !!p && p.toUpperCase().startsWith('B2C_'));
}
